module.exports = __webpack_public_path__ + "img/t_0021.76628248.gif";